interface CheckboxProps {
  isChecked: boolean;
  onCheckboxChange: (checked: boolean) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({ isChecked, onCheckboxChange }) => {
  return (
      <input
        type="checkbox"
        id="my-checkbox"
        className="h-4 w-4 text-primary  border-primary rounded"
        checked={isChecked}
        onChange={(e) => onCheckboxChange(e.target.checked)}
      />
  );
};

export default Checkbox;
